module.exports = {"width":159,"height":50,"url":"/static/media/logo-light.f8f3a946.svg"};